const statusConfig = {
    draft: {
        bg: 'bg-gray-100',
        text: 'text-gray-700',
        icon: (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
        ),
        label: 'Draft',
    },
    submitted: {
        bg: 'bg-blue-100',
        text: 'text-blue-700',
        icon: (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
            </svg>
        ),
        label: 'Submitted',
    },
    quoted: {
        bg: 'bg-indigo-100',
        text: 'text-indigo-700',
        icon: (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
            </svg>
        ),
        label: 'Quoted',
    },
    accepted: {
        bg: 'bg-cyan-100',
        text: 'text-cyan-700',
        icon: (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
        ),
        label: 'Accepted',
    },
    pending: {
        bg: 'bg-yellow-100',
        text: 'text-yellow-700',
        icon: (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        ),
        label: 'Pending',
    },
    approved: {
        bg: 'bg-green-100',
        text: 'text-green-700',
        icon: (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        ),
        label: 'Approved',
    },
    rejected: {
        bg: 'bg-red-100',
        text: 'text-red-700',
        icon: (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
        ),
        label: 'Rejected',
    },
    active: {
        bg: 'bg-emerald-100',
        text: 'text-emerald-700',
        icon: (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
        ),
        label: 'Active',
    },
    paid: {
        bg: 'bg-emerald-100',
        text: 'text-emerald-700',
        icon: (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
        ),
        label: 'Paid',
    },
    unpaid: {
        bg: 'bg-orange-100',
        text: 'text-orange-700',
        icon: (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        ),
        label: 'Unpaid',
    },
    expired: {
        bg: 'bg-gray-200',
        text: 'text-gray-600',
        icon: (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        ),
        label: 'Expired',
    },
};

export default function Badge({ status, className = '' }) {
    const config = statusConfig[status] || {
        bg: 'bg-gray-100',
        text: 'text-gray-700',
        icon: null,
        label: status || 'Unknown',
    };

    return (
        <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium leading-none ${config.bg} ${config.text} ${className}`}
        >
            {config.icon && <span className="flex-shrink-0">{config.icon}</span>}
            <span className="capitalize">{config.label}</span>
        </span>
    );
}